import LaudoCusto from "./laudo-custo";

export default class LaudoSimplificado {
	numeroLaudoFormatado = "";
	unidOperacionalResponsavelCliente = 0;
	sicad = 0;
	codAgenciaSolicitante = 0;
	codTipoCaracteristica = 0;
	codMunicipio = 0;
	codMotivo = 0;
	descMotivo="";
	valor = 0;
	descricao = "";
	cpfcnpj = 0;
	nomeCliente = "";
	telefoneCliente="";
	nomeContato = "";
	telContato = "";
	orgaoSiat = 0;
	anoSolicitacaoSiat = null;
	seqAtividadeSiat = null;
	dataSiat: any = null;
	id? = undefined;
	codigoAgenciaJurisdicao? = undefined;
	custo: LaudoCusto = new LaudoCusto();
	codigoUf? = undefined;
	aporteRecursos?: boolean | null = false;
}
